module.exports = __webpack_public_path__ + "static/media/prof.a4c82f67.jpg";